import { isDepartmentRestricted } from './departmentAccess';
import type { RestaurantMembership } from './types';
import type { NotificationTarget } from './notificationTypes';

export function notificationDestination(target: NotificationTarget, membership: RestaurantMembership, integrationsEnabled: boolean) {
  const restricted = isDepartmentRestricted(membership), manager = ['OWNER', 'MANAGER'].includes(membership.role);
  if (membership.role === 'EMPLOYEE') {
    if (['inventory', 'library', 'shortages', 'counts'].includes(target)) return { staff: 'inventory' as const };
    if (target === 'temperatures' || target === 'equipment') return { staff: target };
    return null;
  }
  if (!['OWNER', 'MANAGER', 'BUYER'].includes(membership.role)) return null;
  if (target === 'temperatures' || target === 'equipment') return { manager: 'operations' as const, operation: target };
  if (target === 'library' || target === 'inventory') return { manager: 'library' as const };
  if (target === 'users') return manager ? { manager: 'users' as const } : null;
  if (target === 'counts') return manager && !restricted ? { manager: 'counts' as const } : null;
  if (target === 'integrations') return !restricted && integrationsEnabled ? { manager: 'integrations' as const } : null;
  if (target === 'purchasing' || target === 'shortages') return !restricted ? { manager: target } : null;
  return null;
}
